<template>
  <div id="p0434Page">
    <el-row style="top: 5px">
      <!-- 新增课程 -->
      <el-row style="bottom: 5px">
        <el-col :span="22" :offset="1">
          <el-button type="p0402add" style="float: left" @click="handleAdd()">{{
            $t("p0433.addCourse")
          }}</el-button>
        </el-col>
      </el-row>
      <el-col :span="22" :offset="1">
        <el-table
          :data="CCTable"
          v-loading="pageLoading"
          style="width: 100%; margin-bottom: 75px"
        >
          <!-- 课程编号 -->
          <el-table-column
            prop="title"
            :label="$t('p0433.courseNumber')"
            align="center"
            width="140px"
          >
            <template slot-scope="scope">
              {{
                scope.row.field + scope.row.category + scope.row.courseNumber
              }}
            </template>
          </el-table-column>
          <!-- 课程名称 -->
          <el-table-column
            prop="courseName"
            :label="$t('p0433.courseName')"
            align="left"
            min-width="100"
          >
          </el-table-column>
          <!-- 培训费用 -->
          <el-table-column
            prop="trainingCosts"
            :label="$t('p0433.trainingCost')"
            align="right"
            width="140px"
          >
          </el-table-column>
          <!-- 货币 -->
          <el-table-column
            prop="currencyNameZh"
            :label="$t('p0433.currency')"
            align="center"
            min-width="40"
          >
          </el-table-column>
          <!-- 操作 -->
          <el-table-column
            :label="$t('common.operation')"
            align="center"
            width="180px"
          >
            <template slot-scope="scope">
              <div class="blueDivider">
                <el-button type="text" @click="handleEdit(scope.row)">{{
                  $t("common.edit")
                }}</el-button>
                <el-divider direction="vertical">{{ "|" }}</el-divider>
                <el-button type="text" @click="open(scope.row)">{{
                  $t("common.delete")
                }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row><br /><br /></el-row>
    <!-- 课程弹窗新增课程 -->
    <el-dialog
      :title="$t('p0433.addCourse')"
      :visible.sync="addDialogV"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="650px"
      class="el-dialog__body"
    >
      <el-form
        class="systemFont1"
        :model="addForm"
        label-width="150px"
        style="width:90%;"
        ref="addFormRef"
        hide-required-asterisk
        label-position="right"
      >
        <!-- 课程编号 -->
        <el-form-item
          :label="$t('p0433.courseNumber')"
          prop="courseNumberIndex"
          :rules="courseNumberIndex1"
        >
          <el-select
            filterable
            clearable
            v-model="addForm.courseNumberIndex"
            size="courseSelect"
            style="width: 100%"
            :placeholder="$t('common.pleaseSelect')"
            @change="changeCourse(addForm.courseNumberIndex)"
          >
            <el-option
              v-for="(item, index) in selectAllLesson"
              :key="item.field + item.category + item.courseNumber"
              :label="item.field + item.category + item.courseNumber"
              :value="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 课程名称 -->
        <el-form-item
          :label="$t('p0433.courseName')"
          prop="courseNumberIndex"
          :rules="courseNumberIndex2"
        >
          <el-select
            filterable
            clearable
            v-model="addForm.courseNumberIndex"
            size="courseSelect"
            style="width: 100%"
            :placeholder="$t('common.pleaseSelect')"
            @change="changeCourse(addForm.courseNumberIndex)"
          >
            <el-option
              v-for="(item, index) in selectAllLesson"
              :key="item.field + item.category + item.courseNumber"
              :label="item.courseName"
              :value="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 培训费用 -->

        <el-row>
          <!-- 培训费用 -->
          <el-col :span="18">
            <el-form-item
              :label="$t('p0433.trainingCost')"
              prop="trainingCosts"
              :rules="trainingCosts"
            >
              <el-input
                v-model="addForm.trainingCosts"
                maxlength="8"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 培训费用下拉 -->
          <el-col :span="5" :offset="1">
            <el-form-item
              prop="currencyType"
              label-width="0px"
              :rules="currencyType"
            >
              <el-select
                v-model="addForm.currencyType"
                size="courseSelect"
                style="width: 100%"
                :placeholder="$t('common.pleaseSelect')"
              >
                <el-option
                  v-for="item in currencySelection"
                  :key="item.codeKey"
                  :label="item.codeValueZh"
                  :value="item.codeKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 差旅费用 -->
        <el-form-item
          :label="$t('p0433.travelExpense')"
          prop="travelExpenses"
          :rules="travelExpenses"
        >
          <el-radio-group v-model="addForm.travelExpenses">
            <el-radio label="0">{{ $t("p0433.uncertain") }}</el-radio>
            <el-radio label="1">{{ $t("p0433.withTravelExpense") }}</el-radio>
            <el-radio label="2">{{
              $t("p0433.withoutTravelExpense")
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div style="text-align: center;margin-bottom:20px">
        <!-- 保存按钮 -->
        <el-button type="p0402create" size="big" @click.native="saveAdd">{{
          $t("common.save")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 课程弹窗编辑课程 -->
    <el-dialog
      :title="$t('p0433.editCourse')"
      :visible.sync="editDialogV"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="650px"
      class="el-dialog__body"
    >
      <el-form
        class="systemFont1"
        :model="editForm"
        label-width="150px"
        style="width:90%;"
        ref="editFormRef"
        hide-required-asterisk
        label-position="right"
      >
        <!-- 课程名称 -->
        <el-form-item :label="$t('p0433.courseName')">
          <span style="color:#606266;font-weight: initial;">{{
            editForm.courseName
          }}</span>
        </el-form-item>
        <!-- 培训费用 -->
        <el-row>
          <!-- 培训费用 -->
          <el-col :span="18">
            <el-form-item
              :label="$t('p0433.trainingCost')"
              prop="trainingCosts"
              :rules="trainingCosts"
            >
              <el-input
                v-model="editForm.trainingCosts"
                maxlength="8"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 培训费用下拉 -->
          <el-col :span="5" :offset="1">
            <el-form-item
              prop="currencyType"
              label-width="0px"
              :rules="currencyType"
            >
              <el-select
                v-model="editForm.currencyType"
                size="courseSelect"
                style="width: 100%"
                :placeholder="$t('common.pleaseSelect')"
              >
                <el-option
                  v-for="item in currencySelection"
                  :key="item.codeKey"
                  :label="item.codeValueZh"
                  :value="item.codeKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 差旅费用 -->
        <el-form-item
          :label="$t('p0433.travelExpense')"
          prop="travelExpenses"
          :rules="travelExpenses"
        >
          <el-radio-group v-model="editForm.travelExpenses">
            <el-radio label="0">{{ $t("p0433.uncertain") }}</el-radio>
            <el-radio label="1">{{ $t("p0433.withTravelExpense") }}</el-radio>
            <el-radio label="2">{{
              $t("p0433.withoutTravelExpense")
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div style="text-align: center;margin-bottom:20px">
        <!-- 保存按钮 -->
        <el-button type="p0402create" size="big" @click.native="saveEdit">{{
          $t("common.save")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    userId: {
      type: Number,
      required: true
    },
    certifiedCoursesWatch: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      // 页面载入状态
      pageLoading: false,
      // 页面数据
      CCTable: [],
      // 对话框隐藏状态
      addDialogV: false,
      editDialogV: false,
      //课程信息
      selectAllLessonRes: [],
      selectAllLesson: [],
      currencySelection: [],
      addForm: {
        createUser: localStorage.getItem("userId"),
        userId: this.userId,
        courseName: "",
        field: "",
        category: "",
        courseNumber: "",
        courseNumberIndex: "",
        trainingCosts: "",
        currencyType: "",
        travelExpenses: "0"
      },
      editForm: {
        updateUser: localStorage.getItem("userId"),
        userId: this.userId,
        recordId: "",
        courseName: "",
        field: "",
        category: "",
        courseNumber: "",
        courseNumberIndex: "",
        trainingCosts: "",
        currencyType: "",
        travelExpenses: "0"
      },
      courseName: [
        {
          required: true,
          message: this.$t("p0433.enterNumber"),
          trigger: "blur"
        }
      ],
      field: [
        {
          required: true,
          message: this.$t("p0433.enterNumber"),
          trigger: "blur"
        }
      ],
      category: [
        {
          required: true,
          message: this.$t("p0433.enterNumber"),
          trigger: "blur"
        }
      ],
      courseNumber: [
        {
          required: true,
          message: this.$t("p0433.enterNumber"),
          trigger: "blur"
        }
      ],
      courseNumberIndex1: [
        {
          required: true,
          // 请选择课程
          message: this.$t("p0433.enterNumber"),
          trigger: "change"
        }
      ],
      courseNumberIndex2: [
        {
          required: true,
          // 请选择课程
          message: this.$t("p0433.enterName"),
          trigger: "change"
        }
      ],
      trainingCosts: [
        {
          required: true,
          message: this.$t("p0433.enterTrainingCost"),
          trigger: "blur"
        },
        {
          pattern: /^(0|[1-9][0-9]*)$/,
          message: this.$t("courseOption.pleaseEnterPositiveInteger"),
          trigger: "blur"
        }
      ],
      currencyType: [
        {
          required: true,
          message: this.$t("p0433.enterNumber"),
          trigger: "change"
        }
      ],
      travelExpenses: [
        {
          required: true,
          message: this.$t("p0433.enterNumber"),
          trigger: "blur"
        }
      ]
    };
  },
  watch: {
    async certifiedCoursesWatch(newValue, oldValue) {
      // 执行初始化操作
      await this.init();
      await this.getLessonApi();
    }
  },
  async mounted() {
    await this.init();
    await this.getLessonApi();
    this.getCurrencyApi();
  },
  methods: {
    // 初始化
    async init() {
      this.CCTable = [];
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#p0434Page")
      });
      let url = "/api/TrainerManagement/selectCertifiedCoursesList";
      await this.$http
        .post(url, {
          userId: this.userId
        })
        .then(response => {
          console.log("🚀 ~ file: P0434.vue:165 ~ init ~ response:", response);
          loading.close();
          if (response.data.code === 200) {
            // 判断有没有数据
            if (response.data.data == null) {
              this.CCTable = [];
            } else {
              // 渲染页面
              this.CCTable = response.data.data;
            }
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    //打开添加课程
    handleAdd() {
      if (this.$refs.addFormRef) {
        // 清空所有值
        this.$refs.addFormRef.clearValidate();
        // 清空所有验证
        this.$refs.addFormRef.resetFields();
      }
      this.addForm.userId = this.userId;
      if (this.currencySelection != null && this.currencySelection.length > 0) {
        this.addForm.currencyType = this.currencySelection[0].codeKey;
      }
      this.addDialogV = true;
    },
    // 打开编辑课程
    handleEdit(row) {
      if (this.$refs.editFormRef) {
        // 清空所有值
        this.$refs.editFormRef.clearValidate();
        // 清空所有验证
        this.$refs.editFormRef.resetFields();
      }
      this.editForm.recordId = row.recordId;
      this.editForm.courseName = row.courseName;
      this.editForm.trainingCosts = row.trainingCosts;
      this.editForm.currencyType = row.currencyType;
      this.editForm.travelExpenses = row.travelExpenses;
      this.editDialogV = true;
    },
    // 保存添加课程
    saveAdd() {
      this.$refs["addFormRef"].validate(valid => {
        if (valid) {
          this.addDialogV = false;
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#p0434Page")
          });
          let url = "/api/TrainerManagement/addCertificationCourses";
          this.$http
            .post(url, this.addForm)
            .then(async response => {
              loading.close();
              if (response.data.code === 200) {
                await this.init();
                this.removeSelectedLessons();
              } else {
                this.$message.error(response.data.message);
              }
            })
            .catch(err => {
              console.log(err);
              loading.close();
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        }
      });
    },
    // 保存编辑课程
    saveEdit() {
      this.$refs["editFormRef"].validate(valid => {
        if (valid) {
          this.editDialogV = false;
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#p0434Page")
          });
          let url = "/api/TrainerManagement/editCertificationCourses";
          this.$http
            .post(url, this.editForm)
            .then(async response => {
              loading.close();
              if (response.data.code === 200) {
                await this.init();
              } else {
                this.$message.error(response.data.message);
              }
            })
            .catch(err => {
              console.log(err);
              loading.close();
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        }
      });
    },
    open(row) {
      this.$confirm(
        this.$t("p0433.deleteCourseWarning"),
        this.$t("common.tips"),
        {
          confirmButtonText: this.$t("common.confirm"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }
      )
        .then(() => {
          this.deleteRow(row);
        })
        .catch(() => {});
    },
    // 删除认证课程
    deleteRow(row) {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#p0434Page")
      });
      let url = "/api/TrainerManagement/deleteCertificationCourses";
      this.$http
        .post(url, {
          updateUser: localStorage.getItem("userId"),
          recordId: row.recordId
        })
        .then(async response => {
          loading.close();
          if (response.data.code === 200) {
            await this.init();
            this.removeSelectedLessons();
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 获取课程选择
    async getLessonApi() {
      let url = "/api/TrainerManagement/selectAllLesson";
      await this.$http
        .post(url)
        .then(response => {
          if (response.data.code === 200) {
            // 判断有没有数据
            if (response.data.data == null) {
              this.selectAllLesson = [];
            } else {
              // 渲染页面
              this.selectAllLessonRes = response.data.data;
              this.removeSelectedLessons();
            }
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 获取货币选择
    getCurrencyApi() {
      let url = "/api/TrainerManagement/currencySelection";
      this.$http
        .post(url)
        .then(response => {
          if (response.data.code === 200) {
            // 判断有没有数据
            if (response.data.data == null) {
              this.currencySelection = [];
            } else {
              // 渲染页面
              this.currencySelection = response.data.data;
              console.log(
                "🚀 ~ file: P0434.vue:181 ~ getLessonApi ~ this.currencySelection:",
                this.currencySelection
              );
            }
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 获取课程选择
    changeCourse(courseNumberIndex) {
      const selectedItem = this.selectAllLesson[courseNumberIndex];
      if (selectedItem) {
        this.addForm.courseNumberIndex = courseNumberIndex;
        this.addForm.field = selectedItem.field;
        this.addForm.category = selectedItem.category;
        this.addForm.courseNumber = selectedItem.courseNumber;
        this.addForm.courseName = selectedItem.courseName;
      }
    },
    removeSelectedLessons() {
      this.selectAllLesson = this.selectAllLessonRes.filter(lesson => {
        // 对于每个lesson，检查CCTable中的三个字段是否与lesson中的相应字段相等
        const match = this.CCTable.some(cc => {
          return (
            cc.field === lesson.field &&
            cc.category === lesson.category &&
            cc.courseNumber === lesson.courseNumber
          );
        });

        // 如果在CCTable中找到匹配的记录，则不保留此lesson（即删除它）
        return !match;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

.blueDivider {
  display: inline-block;
}

.blueDivider >>> .el-divider--vertical {
  background-color: #00b0f0;
}

.foot-container {
  margin: 100px auto 0 auto;
  height: 26px;
  width: 50%;
  text-align: center;
}

/* p0402 */
/* email群模板 */
.el-button--p0402create:focus,
.el-button--p0402create {
  background-color: #00b0f0;
  border-color: rgb(0, 176, 240);
  height: 35px;
  width: 100px;
  white-space: pre-wrap;
  padding: 0 15px;
  font-family: "微软雅黑";
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
  font-size: 13px;
  line-height: 24px;
}

.el-button--p0402save:focus,
.el-button--p0402save {
  background-color: #00b0f0;
  border-color: rgb(0, 176, 240);
  height: 35px;
  width: 130px;
  white-space: pre-wrap;
  padding: 0 15px;
  font-family: "微软雅黑";
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
  font-size: 13px;
  line-height: 24px;
}

/* 返回 */
.el-button--p0402return {
  /* 999999 */
  background-color: #ffffff;
  /* 999999 */
  border-color: #d9d9d9;
  height: 35px;
  width: 100px;
  white-space: pre-wrap;
  padding: 0;
  font-family: "微软雅黑";
  font-weight: 400;
  font-style: normal;
  color: #000000;
  font-size: 13px;
  line-height: 18px;
}

.el-button--p0402add:focus,
.el-button--p0402add {
  background-color: #00b0f0;
  border-color: rgb(0, 176, 240);
  height: 35px;
  width: 100px;
  white-space: pre-wrap;
  padding: 0 15px;
  font-family: "微软雅黑";
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
  font-size: 14px;
  line-height: 24px;
  border-radius: 6px;
}

>>> .el-dialog__body {
  padding-top: 10px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  padding: 3px 30px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/MarketingMgt/P0434.vue